import { createContext } from "react";
import ConfirmDialogContextProps from "./models/ConfirmDialogContextProps";

const ConfirmDialogContext = createContext<ConfirmDialogContextProps>(
  {} as ConfirmDialogContextProps
);

export default ConfirmDialogContext;
